import Image from 'next/image';
import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';

interface ProductCardProps {
  id: number;
  name: string;
  slug: string;
  thumbnail: string;
  description: string;
}

const ProductCard = (props: ProductCardProps) => {
  const { name, thumbnail, description, slug } = props;

  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3 }}
      className="group cursor-pointer"
    >
      <Link href={`/products/${slug}`}>
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col">
          <div className="relative w-full aspect-square overflow-hidden">
            <Image
              src={thumbnail}
              alt={name}
              fill
              className="object-cover transition-transform duration-500 group-hover:scale-110"
              sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
          <div className="p-4 md:p-5 flex flex-col gap-2 flex-1">
            <h3 className="text-[16px] md:text-[18px] font-semibold text-gray2 line-clamp-2 group-hover:text-primary transition-colors duration-300">
              {name}
            </h3>
            <p className="text-[14px] text-gray-600 line-clamp-2 flex-1">
              {description}
            </p>
            <div className="pt-2">
              <span className="text-primary text-[14px] md:text-[16px] font-semibold">
                LIÊN HỆ
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
